module.exports = __webpack_public_path__ + "static/heroDesktop@x2-4f30f762b7ce33e60ae3bce0490244a7.png";